import { Auth } from 'aws-amplify';
import { useEffect, useState } from 'react';

const useCurrentUser = () => {
  const [user, setUser] = useState(undefined);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const currentUser = await Auth.currentAuthenticatedUser();
        setUser(currentUser);
        setIsAdmin('custom:admin_secret' in currentUser.attributes);
      } catch {
        setUser(undefined);
        setIsAdmin(false);
      }
    };

    fetchUser();
  }, []);

  return { user, isAdmin };
};

export default useCurrentUser;
